import { Breadcrumb, CardSkeletonLoader, Modal } from '@/components/atoms';
import { PageHeader, SaveCancelFooter } from '@/components/molecules';
import { PageContainer } from '@/components/organisms';
import ReviewBulkPoint from '@/containers/ReviewBulkPointModifiers/ReviewBulkPoint'
import useReviewBulkPointModifier from '@/containers/ReviewBulkPointModifiers/ReviewBulkPointModifier-hooks';
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { ROUTES } from '@/utils/constants/routesConstants';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom'

const ReviewBulkPointModifiers = () => {
  const { handlePublish, handleDraft, loading } = useReviewBulkPointModifier()
  const [isCancel, setIsCancel] = useState(false);
  const navigate = useNavigate()
  const {id} = useParams()
  const isReadOnly = !id;

  const cancelPopup = () => {
    setIsCancel(!isCancel);
  }
  const onClickPrimaryButton = () => {
    navigate(ROUTES.BULK_POINT_MODIFIERS)
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: '',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },
            {
              href: '',
              label: 'Point Modifiers',
            },
          ],
        }}
        id={'cbpm_bradcrumb'}
      />
      <PageHeader title="Create Bulk Point Modifiers" />
      {loading ? <PageContainer>
        <CardSkeletonLoader> </CardSkeletonLoader>
      </PageContainer> :
        <ReviewBulkPoint/>
      }
      {isReadOnly ? (
        <SaveCancelFooter
          isReview={true}
          handleCancel={cancelPopup}
          nextAction={handlePublish}
          draftAction={handleDraft}
        />
      ) : null}

      {isCancel ? (
        <Modal
          type={MODAL_TYPE.FLUID}
          showModal={isCancel}
          onCloseModal={cancelPopup}
          title="Are you sure you want to cancel?"
          text={'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={onClickPrimaryButton}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={onClickSecondaryButton}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      ) : null}
    </>
  )
}

export default ReviewBulkPointModifiers;